var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component } from 'vue-property-decorator';
import { BContainer, BRow, BCol, BImg } from 'bootstrap-vue';
var AboutUs = /** @class */ (function (_super) {
    __extends(AboutUs, _super);
    function AboutUs() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AboutUs = __decorate([
        Component({
            components: {
                BContainer: BContainer,
                BRow: BRow,
                BCol: BCol,
                BImg: BImg
            },
            metaInfo: {
                title: 'About ePictureMounts - Picture & Photo Mount Specialists',
                meta: [
                    {
                        name: 'description',
                        content: 'We have a team of Fine Art Trade Guild commended picture framers that cut hundreds of picture & photo mounts each and everyday. We are based in Chesterfield, Derbyshire (UK) and specialist in whitecore, conservation and museum grade mountboards.'
                    },
                    {
                        name: 'keywords',
                        content: 'fine art trade guild framers, picture mounts, photo mounts, derbyshire, chesterfield, uk delivery'
                    }
                ]
            }
        })
    ], AboutUs);
    return AboutUs;
}(Vue));
export default AboutUs;
